<!-- <div nz-row>
    <div nz-col nzSpan="16" nzOffset="4" style="text-align: center">
      <h1 class="report-title">
        <span class="c-multi">Iti multumesc</span>
        <span class="small">pentru incredere!</span>
        <br />
        <strong>Iata ce poti vedea in acest raport:</strong>
        <br />
        <span style="font-size: 16px">
          (te poti duce direct pe capitolul care te intereseaza)
        </span>
      </h1>
    </div>
  
  </div> Comparatii, Variatii si Evolutii Perioade-->
<div nz-row>
  <div nz-col nzSpan="24" [ngClass]="['p-3', 'language-status']" *ngIf="isLanguageSelectorVisible">
    <h5 nz-typography style="margin-right: 5px">
      Limba: {{ "system_language" | translate }}
      <nz-select nzPlaceHolder="Selectează limba" [(ngModel)]="sysLanguage" (ngModelChange)="switchLanguage($event)" nzSize="small" style="width: 120px; color: black !important">
        <nz-option nzValue="ro" nzLabel="Română"></nz-option>
        <nz-option nzValue="en" nzLabel="Engleză"></nz-option>
      </nz-select>
    </h5>
  </div>
</div>
<h3 style="text-align: center">
  <br />
  <br />
  {{ "compares_header_title" | translate }}
  <br />
</h3>

<div class="info-columns columns-landscape outline" style="margin-top: 5rem" nz-col nzSpan="16" nzOffset="4" [nzXs]="{ span: 24, offset: 0 }" [nzMd]="{ span: 16, offset: 4 }">
  <ul>
    <li (click)="goToAnchor('slide_1')">
      <span class="number">01</span>
      <p class="cuprins">{{ "first_row" | translate }}</p>
    </li>
    <li (click)="goToAnchor('slide_11')">
      <span class="number">02</span>
      <p class="cuprins">{{ "second_row" | translate }}</p>
    </li>
    <li (click)="goToAnchor('slide_13')">
      <span class="number">03</span>
      <p class="cuprins">{{ "third_row" | translate }}</p>
    </li>
    <li (click)="goToAnchor('slide_15')">
      <span class="number">04</span>
      <p class="cuprins">{{ "forth_row" | translate }}</p>
    </li>
  </ul>
</div>
<div class="btn-row-2" style="margin-left: auto; margin-right: auto; width: 324px" *ngIf="!loadingSlides">
  <a [href]="chartsUrl">
    <button class="evolution-button">
      {{ "evo_graph_text_btn" | translate }}
      <span class="button-custom-icon">
        <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFFFFF"><path d="M120-120v-76l60-60v136h-60Zm165 0v-236l60-60v296h-60Zm165 0v-296l60 61v235h-60Zm165 0v-235l60-60v295h-60Zm165 0v-396l60-60v456h-60ZM120-356v-85l280-278 160 160 280-281v85L560-474 400-634 120-356Z" /></svg>
      </span>
    </button>
  </a>
</div>

<div class="btn-row-2" style="margin-left: auto; margin-right: auto; width: 324px; opacity: 0.2" *ngIf="loadingSlides">
  <button class="evolution-button">
    {{ "evo_graph_text_btn" | translate }}
    <span class="button-custom-icon">
      <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFFFFF"><path d="M120-120v-76l60-60v136h-60Zm165 0v-236l60-60v296h-60Zm165 0v-296l60 61v235h-60Zm165 0v-235l60-60v295h-60Zm165 0v-396l60-60v456h-60ZM120-356v-85l280-278 160 160 280-281v85L560-474 400-634 120-356Z" /></svg>
    </span>
  </button>
</div>

<div id="topHead">
  <nz-spin [nzSpinning]="loadingSlides">
    <div *ngFor="let slide of textSlides; index as i" id="slide_{{ i }}" class="slides previewContainer_{{ slide.id }}">
      <div nz-row class="other" *ngIf="excludeFromCompare.indexOf(slide.id) == -1">
        <div nz-col nzSpan="18" nzOffset="4" [nzXs]="{ span: 24, offset: 0 }" [nzMd]="{ span: 18, offset: 4 }">
          <h3 nz-typography class="p-title" *ngIf="slide.showTitle && slide.chartType != 'table1' && slide.id !=51" [innerHtml]="convert(slide.title)">
            {{ slide.title }}
          </h3>
          <!-- >>>{{ slide.id }} {{ slide.tableName }} -->
          <div *ngIf="slide.slideClass == 'tableChart' || slide.chartType == 'table'">
            <!--               [nzScroll]="{ x: '800px', y: '600px' }"
  -->

            <ng-container *ngIf="slide.tableName == 'concluzii1'">
              <h3>{{ "conc_table1_title" | translate }}</h3>
            </ng-container>
            <nz-table #slideTable [nzData]="[1]" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed" [ngClass]="'conclusions_table'" [nzScroll]="{ x: '200px', y: '600px' }">
              <thead>
                <!-- <col>
              <colgroup span="2"></colgroup>
              <colgroup span="2"></colgroup>
              <tr><td style="background-color: #2bb3ac !important;" nzLeft nzWidth="300px"></td>
                <th [attr.colspan]="c.length" scope="colgroup" style="background-color: slateblue !important;" nzWidth="100px">Evolutie perioade</th>
                <th [attr.colspan]="diff.length" scope="colgroup" style="background-color: cornflowerblue !important;" nzWidth="100px">Variatii intre perioade</th>
              </tr> -->

                <tr>
                  <!-- Expand column for P&L and Bilant tables -->
                  <th rowspan="2" nzLeft nzWidth="50px" style="background-color: #2bb3ac !important" *ngIf="slide.tableName == 'bp_totals1' || slide.tableName == 't2'"></th>
                  <!-- <th nzLeft nzWidth="300px">{{ 'table_title_desc' | translate }}</th> -->
                  <th rowspan="2" style="background-color: #2bb3ac !important" nzLeft nzWidth="300px">{{ "table_title_desc" | translate }}</th>
                  <ng-container *ngFor="let cc of c; let j = index">
                    <th style="text-align: right; background-color: slateblue !important" nzWidth="100px">{{ months[cc.month - 1] }} {{ cc.year }}</th>
                  </ng-container>
                  <ng-container *ngFor="let d of diff">
                    <th style="text-align: right; background-color: cornflowerblue !important" nzWidth="100px">
                      <div style="white-space: pre-wrap">{{ d }}</div>
                    </th>
                  </ng-container>
                </tr>
                <tr>
                  <!-- <tr><th rowspan="2" style="background-color: #2bb3ac !important;" nzLeft nzWidth="300px">{{ 'table_title_desc' | translate }}</th> -->
                  <th [attr.colspan]="c.length" scope="colgroup" style="background-color: slateblue !important">{{ "compa_evo_per" | translate }}</th>
                  <th [attr.colspan]="diff.length" scope="colgroup" style="background-color: cornflowerblue !important">{{ "compa_var_per" | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <!-- {{
                    slide.tableData
                  }} ..<<< -->
                <ng-container *ngFor="let item of slide.tableData | keyvalue : keepOriginalOrder">
                  <tr
                    [ngClass]="{
                      highlight:
                        item.key == 'Profitul din balanta' ||
                        item.key == 'Cash-ul din banci si casierie' ||
                        (item.key == 'Profit net' && slide.tableName != 't2') ||
                        item.key == '%' ||
                        item.key == 'Adaos comercial' ||
                        item.key == 'Check 1' ||
                        item.key == 'Check 2' ||
                        item.key == 'Ratii Bilantiere' ||
                        item.key == 'Rotatia Capitalului de Lucru' ||
                        item.key == 'Rate de indatorare (acesti trei indicatori sunt relevanti numai la nivel de an - balanta Decembrie)' ||
                        item.key == 'Indicatori de performanta' ||
                        item.key == 'Indicatori de Lichiditate',
                      lowlight: item.key == 'Diferente' || item.key == 'EBITDA' || item.key == 'EBIT' || item.key == 'Profit din alte activitati' || item.key == 'Profit financiar' || (item.key == 'Profit net' && slide.tableName == 't2') || item.key == 'TOTAL ACTIV' || item.key == 'TOTAL PASIV',
                      tablehead: item.key == 'VENITURI OPERATIONALE'
                    }"
                    *ngIf="(userRole == 'admin' && (item.key === 'Check 1' || item.key === 'Check 2' || item.key === 'Profit net din balanta')) || (item.key !== 'Check 1' && item.key !== 'Check 2' && item.key !== 'Profit net din balanta')"
                  >
                    <!-- Expand cell for P&L table (bp_totals1 maps to t1) -->
                    <td nzLeft [nzExpand]="expandSet.has(getRowId('t1', item.key))"
                        (nzExpandChange)="onExpandChange(getRowId('t1', item.key), $event)"
                        *ngIf="slide.tableName == 'bp_totals1' && isExpandable('t1', item.key)"></td>
                    <td nzLeft *ngIf="slide.tableName == 'bp_totals1' && !isExpandable('t1', item.key)"></td>
                    <!-- Expand cell for Bilant table (t2) -->
                    <td nzLeft [nzExpand]="expandSet.has(getRowId('t2', item.key))"
                        (nzExpandChange)="onExpandChange(getRowId('t2', item.key), $event)"
                        *ngIf="slide.tableName == 't2' && isExpandable('t2', item.key)"></td>
                    <td nzLeft *ngIf="slide.tableName == 't2' && !isExpandable('t2', item.key)"></td>
                    <td nzLeft *ngIf="(item.key == 'Ratii Bilantiere' || item.key == 'Rotatia Capitalului de Lucru' || item.key == 'Rate de indatorare (acesti trei indicatori sunt relevanti numai la nivel de an - balanta Decembrie)' || item.key == 'Indicatori de performanta' || item.key == 'Indicatori de Lichiditate') && loadingKpi == false" [attr.colspan]="1 + c.length + diff.length">
                      {{ item.key | translate }}
                    </td>
                    <td nzLeft *ngIf="item.key != 'Ratii Bilantiere' && item.key != 'Rotatia Capitalului de Lucru' && item.key != 'Rate de indatorare (acesti trei indicatori sunt relevanti numai la nivel de an - balanta Decembrie)' && item.key != 'Indicatori de performanta' && item.key != 'Indicatori de Lichiditate'">
                      {{ item.key | translate }}
                    </td>
                    <ng-container *ngFor="let value of item.value; let k = index">
                      <!-- Only show values for expected columns: c.length periods + diff.length variations -->
                      <ng-container *ngIf="k < c.length + diff.length">
                        <ng-container *ngIf="slide.tableName == 'kpi' && item.key != 'Ratii Bilantiere' && item.key != 'Rotatia Capitalului de Lucru' && item.key != 'Rate de indatorare (acesti trei indicatori sunt relevanti numai la nivel de an - balanta Decembrie)' && item.key != 'Indicatori de performanta' && item.key != 'Indicatori de Lichiditate'">
                          <td class="kpi_value" [ngClass]="kpiResults[value]" *ngIf="k < c.length">
                            {{ value | number : "0.0-2" : "ro" }}
                          </td>
                          <td class="kpi_value" *ngIf="k >= c.length">
                            {{ value | number : "0.0-2" : "ro" }}
                          </td>
                        </ng-container>
                        <ng-container *ngIf="slide.tableName != 'kpi'">
                          <td style="text-align: right" [ngClass]="{ negative: value < 0 }">
                            <ng-container *ngIf="isNumber(value)">{{ value | number : "1.0-0" : "ro" }}</ng-container>
                            <ng-container *ngIf="!isNumber(value)">{{ value | translate }}</ng-container>
                          </td>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </tr>
                  <!-- Expanded rows for P&L table - GROUPS -->
                  <ng-container *ngIf="slide.tableName == 'bp_totals1' && hasGroup('t1', item.key) && expandSet.has(getRowId('t1', item.key))">
                    <ng-container *ngFor="let group of getGroup('t1', item.key)">
                      <!-- Group row -->
                      <tr class="group-row">
                        <td nzLeft style="width: 50px;"
                            [nzExpand]="expandSet.has(group.id)"
                            (nzExpandChange)="onExpandChange(group.id, $event)"
                            *ngIf="group.accountTypeId"></td>
                        <td nzLeft style="width: 50px;" *ngIf="!group.accountTypeId"></td>
                        <td nzLeft style="width: 300px;" class="group-desc">{{ group.description | translate }}</td>
                        <!-- Group values for all periods -->
                        <ng-container *ngFor="let cc of c; let idx = index">
                          <td style="text-align: right; width: 100px;" [ngClass]="{ negative: getGroupValues(group.id)[idx] < 0 }">
                            <ng-container *ngIf="isNumber(getGroupValues(group.id)[idx])">{{ getGroupValues(group.id)[idx] | number : "1.0-0" : "ro" }}</ng-container>
                            <ng-container *ngIf="!isNumber(getGroupValues(group.id)[idx])">0</ng-container>
                          </td>
                        </ng-container>
                        <!-- Group variations -->
                        <ng-container *ngFor="let d of diff; let dIdx = index">
                          <td style="text-align: right; width: 100px;" [ngClass]="{ negative: getGroupValues(group.id)[c.length + dIdx] < 0 }">
                            <ng-container *ngIf="isNumber(getGroupValues(group.id)[c.length + dIdx])">{{ getGroupValues(group.id)[c.length + dIdx] | number : "1.0-0" : "ro" }}</ng-container>
                            <ng-container *ngIf="!isNumber(getGroupValues(group.id)[c.length + dIdx])">0</ng-container>
                          </td>
                        </ng-container>
                      </tr>
                      <!-- Group's sub-accounts -->
                      <ng-container *ngIf="group.accountTypeId && expandSet.has(group.id)">
                        <tr *ngFor="let subAcc of getSubAccountsArray(group.accountTypeId)" class="sub-account-row">
                          <td nzLeft style="width: 50px;"></td>
                          <td nzLeft style="width: 300px;" class="sub-account-desc">{{ subAcc.description | translate }}</td>
                          <ng-container *ngFor="let cc of c; let idx = index">
                            <td style="text-align: right; width: 100px;" [ngClass]="{ negative: subAcc.values[idx] < 0 }">
                              <ng-container *ngIf="isNumber(subAcc.values[idx])">{{ subAcc.values[idx] | number : "1.0-0" : "ro" }}</ng-container>
                              <ng-container *ngIf="!isNumber(subAcc.values[idx])">0</ng-container>
                            </td>
                          </ng-container>
                          <ng-container *ngFor="let d of diff; let dIdx = index">
                            <td style="text-align: right; width: 100px;" [ngClass]="{ negative: subAcc.values[c.length + dIdx] < 0 }">
                              <ng-container *ngIf="isNumber(subAcc.values[c.length + dIdx])">{{ subAcc.values[c.length + dIdx] | number : "1.0-0" : "ro" }}</ng-container>
                              <ng-container *ngIf="!isNumber(subAcc.values[c.length + dIdx])">0</ng-container>
                            </td>
                          </ng-container>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <!-- Expanded rows for P&L table - DIRECT ACCOUNTS (no group) -->
                  <ng-container *ngIf="slide.tableName == 'bp_totals1' && !hasGroup('t1', item.key) && isExpandable('t1', item.key) && expandSet.has(getRowId('t1', item.key))">
                    <tr *ngFor="let subAcc of getSubAccountsArray(getAccountTypeId('t1', item.key))" class="sub-account-row">
                      <td nzLeft style="width: 50px;"></td>
                      <td nzLeft style="width: 300px;" class="sub-account-desc">{{ subAcc.description | translate }}</td>
                      <ng-container *ngFor="let cc of c; let idx = index">
                        <td style="text-align: right; width: 100px;" [ngClass]="{ negative: subAcc.values[idx] < 0 }">
                          <ng-container *ngIf="isNumber(subAcc.values[idx])">{{ subAcc.values[idx] | number : "1.0-0" : "ro" }}</ng-container>
                          <ng-container *ngIf="!isNumber(subAcc.values[idx])">0</ng-container>
                        </td>
                      </ng-container>
                      <ng-container *ngFor="let d of diff; let dIdx = index">
                        <td style="text-align: right; width: 100px;" [ngClass]="{ negative: subAcc.values[c.length + dIdx] < 0 }">
                          <ng-container *ngIf="isNumber(subAcc.values[c.length + dIdx])">{{ subAcc.values[c.length + dIdx] | number : "1.0-0" : "ro" }}</ng-container>
                          <ng-container *ngIf="!isNumber(subAcc.values[c.length + dIdx])">0</ng-container>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-container>
                  <!-- Expanded rows for Bilant table - GROUPS -->
                  <ng-container *ngIf="slide.tableName == 't2' && hasGroup('t2', item.key) && expandSet.has(getRowId('t2', item.key))">
                    <ng-container *ngFor="let group of getGroup('t2', item.key)">
                      <!-- Group row -->
                      <tr class="group-row">
                        <td nzLeft style="width: 50px;"
                            [nzExpand]="expandSet.has(group.id)"
                            (nzExpandChange)="onExpandChange(group.id, $event)"
                            *ngIf="group.accountTypeId"></td>
                        <td nzLeft style="width: 50px;" *ngIf="!group.accountTypeId"></td>
                        <td nzLeft style="width: 300px;" class="group-desc">{{ group.description | translate }}</td>
                        <!-- Group values for all periods -->
                        <ng-container *ngFor="let cc of c; let idx = index">
                          <td style="text-align: right; width: 100px;" [ngClass]="{ negative: getGroupValues(group.id)[idx] < 0 }">
                            <ng-container *ngIf="isNumber(getGroupValues(group.id)[idx])">{{ getGroupValues(group.id)[idx] | number : "1.0-0" : "ro" }}</ng-container>
                            <ng-container *ngIf="!isNumber(getGroupValues(group.id)[idx])">0</ng-container>
                          </td>
                        </ng-container>
                        <!-- Group variations -->
                        <ng-container *ngFor="let d of diff; let dIdx = index">
                          <td style="text-align: right; width: 100px;" [ngClass]="{ negative: getGroupValues(group.id)[c.length + dIdx] < 0 }">
                            <ng-container *ngIf="isNumber(getGroupValues(group.id)[c.length + dIdx])">{{ getGroupValues(group.id)[c.length + dIdx] | number : "1.0-0" : "ro" }}</ng-container>
                            <ng-container *ngIf="!isNumber(getGroupValues(group.id)[c.length + dIdx])">0</ng-container>
                          </td>
                        </ng-container>
                      </tr>
                      <!-- Group's sub-accounts -->
                      <ng-container *ngIf="group.accountTypeId && expandSet.has(group.id)">
                        <tr *ngFor="let subAcc of getSubAccountsArray(group.accountTypeId)" class="sub-account-row">
                          <td nzLeft style="width: 50px;"></td>
                          <td nzLeft style="width: 300px;" class="sub-account-desc">{{ subAcc.description | translate }}</td>
                          <ng-container *ngFor="let cc of c; let idx = index">
                            <td style="text-align: right; width: 100px;" [ngClass]="{ negative: subAcc.values[idx] < 0 }">
                              <ng-container *ngIf="isNumber(subAcc.values[idx])">{{ subAcc.values[idx] | number : "1.0-0" : "ro" }}</ng-container>
                              <ng-container *ngIf="!isNumber(subAcc.values[idx])">0</ng-container>
                            </td>
                          </ng-container>
                          <ng-container *ngFor="let d of diff; let dIdx = index">
                            <td style="text-align: right; width: 100px;" [ngClass]="{ negative: subAcc.values[c.length + dIdx] < 0 }">
                              <ng-container *ngIf="isNumber(subAcc.values[c.length + dIdx])">{{ subAcc.values[c.length + dIdx] | number : "1.0-0" : "ro" }}</ng-container>
                              <ng-container *ngIf="!isNumber(subAcc.values[c.length + dIdx])">0</ng-container>
                            </td>
                          </ng-container>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <!-- Expanded rows for Bilant table - DIRECT ACCOUNTS (no group) -->
                  <ng-container *ngIf="slide.tableName == 't2' && !hasGroup('t2', item.key) && isExpandable('t2', item.key) && expandSet.has(getRowId('t2', item.key))">
                    <tr *ngFor="let subAcc of getSubAccountsArray(getAccountTypeId('t2', item.key))" class="sub-account-row">
                      <td nzLeft style="width: 50px;"></td>
                      <td nzLeft style="width: 300px;" class="sub-account-desc">{{ subAcc.description | translate }}</td>
                      <ng-container *ngFor="let cc of c; let idx = index">
                        <td style="text-align: right; width: 100px;" [ngClass]="{ negative: subAcc.values[idx] < 0 }">
                          <ng-container *ngIf="isNumber(subAcc.values[idx])">{{ subAcc.values[idx] | number : "1.0-0" : "ro" }}</ng-container>
                          <ng-container *ngIf="!isNumber(subAcc.values[idx])">0</ng-container>
                        </td>
                      </ng-container>
                      <ng-container *ngFor="let d of diff; let dIdx = index">
                        <td style="text-align: right; width: 100px;" [ngClass]="{ negative: subAcc.values[c.length + dIdx] < 0 }">
                          <ng-container *ngIf="isNumber(subAcc.values[c.length + dIdx])">{{ subAcc.values[c.length + dIdx] | number : "1.0-0" : "ro" }}</ng-container>
                          <ng-container *ngIf="!isNumber(subAcc.values[c.length + dIdx])">0</ng-container>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </nz-table>

            <!--- DUBLARE TABEL % -->
            <ng-container *ngIf="slide.tableName == 'concluzii1'">
              <h3>{{ "conc_table2_title" | translate }}</h3>
            </ng-container>
            <ng-container *ngIf="slide.tableName == 'concluzii1'">
              <br />
              <br />
              <nz-table #slideTable [nzData]="[1]" nzSize="small" [nzFrontPagination]="false" nzTableLayout="fixed" [ngClass]="'conclusions_table'" [nzScroll]="{ x: '800px', y: '600px' }">
                <thead>
                  <tr>
                    <th nzLeft style="width: 300px">{{ "table_title_desc" | translate }}</th>
                    <ng-container *ngFor="let cc of c; let j = index">
                      <th style="text-align: right">{{ months[cc.month - 1] }} {{ cc.year }}</th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody>
                  <!-- {{
                    slide.tableData
                  }} ..<<< -->
                  <ng-container *ngFor="let item of conclusion['concluzii1p'] | keyvalue : keepOriginalOrder">
                    <tr
                      [ngClass]="{
                        highlight: item.key == 'Profitul din balanta' || item.key == 'Cash-ul din banci si casierie' || item.key == 'Profit net' || item.key == '%' || item.key == 'Adaos comercial',
                        lowlight: item.key == 'Diferente',
                        tablehead: item.key == 'VENITURI OPERATIONALE'
                      }"
                    >
                      <td nzLeft>{{ item.key | translate }}</td>
                      <ng-container *ngFor="let value of item.value">
                        <td style="text-align: right" [ngClass]="{ negative: value < 0 }">
                          <ng-container *ngIf="isNumber(value)">{{ value | number : "1.0-0" : "ro" }}</ng-container>
                          <ng-container *ngIf="!isNumber(value)">{{ value | translate }}</ng-container>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-container>
                </tbody>
              </nz-table>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </nz-spin>
</div>

<nz-spin [nzSpinning]="loadingSlides">
  <div nz-row class="print-pdf">
    <div nz-col nzSpan="12" nzOffset="6" [nzXs]="{ span: 24, offset: 0 }" [nzMd]="{ span: 12, offset: 6 }"></div>
  </div>
</nz-spin>
